define("powergen/models/utilities",
  [],
  function() {
    "use strict";
    var Utilities;

    Utilities = Ember.Object.create({
      randomInt: function(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      },
      styleString: function(styles) {
        var property, styleString, value;
        styleString = '';
        for (property in styles) {
          value = styles[property];
          if (['transition', 'transitionDuration', 'transform'].contains(property)) {
            property = Modernizr.cssprefixed(property);
          }
          styleString += "" + property + ": " + value + ";";
        }
        return styleString;
      }
    });


    return Utilities;
  });